var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_185610_34854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 0.798828H1.99963C1.72307 0.798828 1.49963 1.02227 1.49963 1.29883V14.2988C1.49963 14.5754 1.72307 14.7988 1.99963 14.7988H11.9996C12.2762 14.7988 12.4996 14.5754 12.4996 14.2988V1.29883C12.4996 1.02227 12.2762 0.798828 11.9996 0.798828ZM11.3746 13.6738H2.62463V10.5332H4.15432C4.33557 11.0457 4.65432 11.5066 5.07776 11.8566C5.61682 12.302 6.29963 12.5488 6.99963 12.5488C7.69963 12.5488 8.38245 12.3035 8.92151 11.8566C9.34495 11.5066 9.6637 11.0457 9.84495 10.5332H11.3746V9.54883H9.05588L8.97464 9.93477C8.78714 10.8691 7.95588 11.5488 6.99963 11.5488C6.04338 11.5488 5.21213 10.8691 5.02307 9.93477L4.94182 9.54883H2.62463V1.92383H11.3746V13.6738ZM3.99963 5.12695H9.99963C10.0684 5.12695 10.1246 5.0707 10.1246 5.00195V4.25195C10.1246 4.1832 10.0684 4.12695 9.99963 4.12695H3.99963C3.93088 4.12695 3.87463 4.1832 3.87463 4.25195V5.00195C3.87463 5.0707 3.93088 5.12695 3.99963 5.12695ZM3.99963 7.62695H9.99963C10.0684 7.62695 10.1246 7.5707 10.1246 7.50195V6.75195C10.1246 6.6832 10.0684 6.62695 9.99963 6.62695H3.99963C3.93088 6.62695 3.87463 6.6832 3.87463 6.75195V7.50195C3.87463 7.5707 3.93088 7.62695 3.99963 7.62695Z",
    fill: "#F8F8F8",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_185610_34854"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.798828)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.e15f99da524832e3273cf34b1da62278.svg";
export { ForwardRef as ReactComponent };